import { Button, cardClass } from '@ledgerloom/ui';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../hooks';
import { useSession } from '../session';
import { Icon } from '../components/ui';

// The phone tab bar's overflow: every destination that has no tab of its own.
// Pattern: navigation/navigation-menu, as a list of links.
export function More({ nav }: { nav: Array<{ to: string; label: string; icon: string }> }) {
  const { me, signOut } = useSession();
  usePageTitle('More');
  return (
    <div className="stack">
      <div className="page-head"><div><h1>More</h1><p>{me.display_name} · {me.email} · {me.role} · {me.tenant_name}</p></div></div>
      <nav className={`${cardClass} list more-list`} aria-label="More">
        {nav.map((n) => <Link key={n.to} to={n.to} className="list-item"><Icon name={n.icon} /><span className="grow">{n.label}</span><Icon name="chevron" /></Link>)}
      </nav>
      <div><Button type="button" variant="secondary" onClick={signOut}>Sign out</Button></div>
    </div>
  );
}
